var map = {
	"./CollectionCarousel": 348,
	"./CollectionCarousel.js": 348,
	"./CollectionDetails": 358,
	"./CollectionDetails.js": 358,
	"./CollectionList": 180,
	"./CollectionList.js": 180,
	"./ReactButtonContainer": 241,
	"./ReactButtonContainer.jsx": 241,
	"./ReactButtonContainer.scss": 390,
	"./ReactIIIFTranscript": 391,
	"./ReactIIIFTranscript.jsx": 391,
	"./Search": 198,
	"./Search.js": 198,
	"./collection_index": 418,
	"./collection_index.html": 685,
	"./collection_index.js": 418,
	"./collection_view": 419,
	"./collection_view.html": 686,
	"./collection_view.js": 419,
	"./collections/Collection": 75,
	"./collections/Collection.scss": 75,
	"./collections/CollectionCardBody": 110,
	"./collections/CollectionCardBody.js": 110,
	"./collections/CollectionCardShell": 108,
	"./collections/CollectionCardShell.js": 108,
	"./collections/CollectionCardThumbnail": 109,
	"./collections/CollectionCardThumbnail.js": 109,
	"./collections/CollectionsFilterNoResults": 111,
	"./collections/CollectionsFilterNoResults.js": 111,
	"./collections/landing/FacetBadges": 420,
	"./collections/landing/FacetBadges.js": 420,
	"./collections/landing/FacetPanel": 196,
	"./collections/landing/FacetPanel.js": 196,
	"./collections/landing/Facets": 421,
	"./collections/landing/Facets.js": 421,
	"./collections/landing/Pagination": 140,
	"./collections/landing/Pagination.js": 140,
	"./collections/landing/SearchResults": 194,
	"./collections/landing/SearchResults.js": 194,
	"./collections/landing/SearchResultsCard": 195,
	"./collections/landing/SearchResultsCard.js": 195,
	"./collections/list/ButtonCollectionListShowAll": 184,
	"./collections/list/ButtonCollectionListShowAll.js": 184,
	"./collections/list/CollectionCard": 94,
	"./collections/list/CollectionCard.js": 94,
	"./collections/list/CollectionListStickyUtils": 181,
	"./collections/list/CollectionListStickyUtils.js": 181,
	"./collections/list/CollectionsSortedByAZ": 185,
	"./collections/list/CollectionsSortedByAZ.js": 185,
	"./collections/list/CollectionsSortedByUnit": 182,
	"./collections/list/CollectionsSortedByUnit.js": 182,
	"./collections/list/Unit": 183,
	"./collections/list/Unit.js": 183,
	"./ui/LoadingSpinner": 112,
	"./ui/LoadingSpinner.js": 112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 441;